<template>
    <div class="circle-page">
        <!-- ========== 人群管理：列表 ========== -->
        <div class="page-title">人群管理 <small>规则人群 · 手动同步剔除失效成员</small></div>
        <div class="stat-row">
            <div class="stat-card"><div class="stat-label"><span class="dot" style="background:var(--primary)"></span>人群总数</div><div class="stat-value">{{ summary.audience_total == null ? '—' : fmtInt(summary.audience_total) }}</div><div class="stat-sub">本月新增 {{ summary.current_month_created_count == null ? '-' : fmtInt(summary.current_month_created_count) }} 个</div></div>
            <div class="stat-card"><div class="stat-label"><span class="dot" style="background:var(--green)"></span>累计覆盖客户</div><div class="stat-value">{{ summary.member_cover_total == null ? '—' : fmtInt(summary.member_cover_total) }}<span class="unit">人</span></div><div class="stat-sub">去重后（跨人群）</div></div>
        </div>
        <div class="toolbar">
            <el-input v-model="state.q" class="search-input" placeholder="搜索人群名称 / 分类…" clearable @input="onSearchInput" />
            <div class="spacer"></div>
            <!-- <el-button class="btn-ghost" @click="onSyncAll">⟳ 同步全部</el-button> -->
            <el-button class="btn-ghost" @click="openExportList">导出列表</el-button>
            <el-button class="btn-primary" @click="openNewCrowd">＋ 新建人群</el-button>
        </div>
        <div class="table-wrap">
            <el-table
                class="ref-table"
                :data="mgmtRows"
                v-loading="loading"
                :header-cell-style="{ background: '#FBFCFE', color: '#64748B', fontWeight: '700', fontSize: '14px' }"
                empty-text="没有符合条件的人群"
                style="width: 100%">
                <el-table-column label="人群名称" min-width="180">
                    <template #default="scope">
                        <div class="name-cell">{{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="创建方式" min-width="110">
                    <template #default="scope">
                        <span class="type-tag" :class="scope.row.type === 'import' ? 'imp' : 'rule'">{{ scope.row.type === 'import' ? '人群包导入' : '规则圈选' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="人群分类" min-width="120">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.cat }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="覆盖人数" min-width="100">
                    <template #default="scope">
                        <span class="count-cell">{{ fmtInt(scope.row.member_count) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建人" min-width="110">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.owner }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="人群创建时间" min-width="160">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.created }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="同步时间" min-width="160">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.lastSync || '—' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" min-width="110">
                    <template #default="scope">
                        <span class="badge" :class="calStatusCls(scope.row.status)">{{ calStatusLabel(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="280">
                    <template #default="scope">
                        <span v-if="Number(scope.row.status) === 2" class="op" @click="onExportRow(scope.row)">下载</span>
                        <span v-if="Number(scope.row.status) === 3" class="op" @click="onRecalc(scope.row)">重新计算</span>
                        <!-- <span class="op" @click="onSyncRow(scope.row)">同步</span> -->
                        <span class="op" @click="onViewRow(scope.row)">查看人群</span>
                        <span class="op" @click="onEditRow(scope.row)">编辑</span>
                        <span class="op op-del" @click="onDelRow(scope.row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页（Element Plus 翻页组件） -->
            <pagechange :total="mgmtTotal" :nowpage="state.page" @page_change="mgmtPageChange" />
        </div>

        <!-- 删除确认弹窗 -->
        <el-dialog v-model="delDialog" title="删除人群" width="420px">
            <p>确认删除人群「<b>{{ delName }}</b>」？</p>
            <p style="color:var(--muted);font-size:14px;line-height:1.7">删除后该人群下的客户分群关系将释放，关联触达任务不受影响但不可再引用此人群。</p>
            <template #footer>
                <el-button @click="delDialog = false">取消</el-button>
                <el-button type="primary" style="background:var(--red);border-color:var(--red)" @click="onDelConfirm">删除</el-button>
            </template>
        </el-dialog>

        <!-- 人群同步 · 失效剔除结果弹窗 -->
        <el-dialog v-model="syncDialog" title="人群同步 · 失效剔除结果" width="960px">
            <p v-html="syncSummaryHtml" style="color:var(--muted);font-size:14px;line-height:1.7;margin:6px 0 0"></p>
            <div class="table-wrap" style="margin-top:14px">
                <el-table
                    class="ref-table"
                    :data="syncRows"
                    :header-cell-style="{ background: '#FBFCFE', color: '#64748B', fontWeight: '700', fontSize: '14px' }"
                    empty-text="无记录"
                    style="width: 100%">
                    <el-table-column label="同步时间" min-width="150">
                        <template #default="scope"><span class="muted-cell">{{ scope.row.time }}</span></template>
                    </el-table-column>
                    <el-table-column label="人群" min-width="160">
                        <template #default="scope">{{ scope.row.name }}</template>
                    </el-table-column>
                    <el-table-column label="剔除人数" min-width="90">
                        <template #default="scope"><span style="color:var(--red);font-weight:700">{{ scope.row.removed }}</span></template>
                    </el-table-column>
                    <el-table-column label="其中·年龄失效" min-width="110">
                        <template #default="scope"><span class="muted-cell">{{ scope.row.byAge }}</span></template>
                    </el-table-column>
                    <el-table-column label="其中·黑名单" min-width="110">
                        <template #default="scope"><span class="muted-cell">{{ scope.row.byBlack }}</span></template>
                    </el-table-column>
                    <el-table-column label="保留人数" min-width="100">
                        <template #default="scope"><span class="count-cell">{{ fmtInt(scope.row.keep) }}</span></template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer>
                <el-button type="primary" @click="syncDialog = false">知道了</el-button>
            </template>
        </el-dialog>

        <!-- 编辑人群弹窗 -->
        <el-dialog v-model="editDialog" title="编辑人群" width="380px">
            <label style="font-size:13.5px;color:var(--muted);font-weight:600;display:block;margin:12px 0 5px">人群名称</label>
            <el-input v-model="editName" placeholder="如：山东未激活设备客户"  clearable />
            <label style="font-size:13.5px;color:var(--muted);font-weight:600;display:block;margin:12px 0 5px">人群分类</label>
            <el-input v-model="editCat" placeholder="如：设备激活催办"  clearable />
            <template #footer>
                <el-button @click="editDialog = false">取消</el-button>
                <el-button type="primary" @click="onEditConfirm">保存</el-button>
            </template>
        </el-dialog>

        <!-- 导出记录（人群成员导出，type=2） -->
        <el-dialog v-model="exportListDialog" title="导出记录" width="768px">
            <el-table
                class="ref-table"
                :data="exportListRows"
                :header-cell-style="{ background: '#FBFCFE', color: '#64748B', fontWeight: '700', fontSize: '14px' }"
                empty-text="暂无导出记录"
                style="width: 100%">
                <el-table-column prop="created_at" align="center" label="导出时间" min-width="160" />
                <el-table-column align="center" label="状态" min-width="100">
                    <template #default="scope">
                        <span v-if="scope.row.status==0">待执行</span>
                        <span v-else-if="scope.row.status==1">执行中</span>
                        <span v-else-if="scope.row.status==2">执行完成</span>
                        <span v-else-if="scope.row.status==3">执行失败</span>
                        <span v-else>{{ scope.row.status }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="100">
                    <template #default="scope">
                        <el-button v-if="scope.row.status==2" size="small" type="text" style="color:#4F46E5" @click="handleExportDown(scope.row.local_path)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <el-button @click="exportListDialog = false">取消</el-button>
                <el-button type="primary" style="background:var(--primary);border-color:var(--primary)" @click="exportListDialog = false">确认</el-button>
            </template>
        </el-dialog>

        <!-- 新建人群：选择创建方式 -->
        <el-dialog v-model="newCrowdDialog" title="新建人群" width="560px" align-center>
            <p class="choose-hint">选择创建方式。两种方式创建的人群都进入同一张人群列表，用「创建方式」区分。</p>
            <div class="choose-list">
                <div class="choose-card" @click="goSeg">
                    <div class="choose-ico src-rule">圈</div>
                    <div>
                        <div class="choose-t">智能圈选创建</div>
                        <div class="choose-s">配置条件圈选客户，保存时生成一份固定名单快照，不再自动重算。</div>
                    </div>
                </div>
                <div class="choose-card" @click="openImport">
                    <div class="choose-ico src-import">导</div>
                    <div>
                        <div class="choose-t">导入人群包</div>
                        <div class="choose-s">上传 手机号 / 好友关系ID 名单，匹配已有客户后生成人群，未匹配记录跳过。</div>
                    </div>
                </div>
            </div>
            <template #footer>
                <el-button @click="newCrowdDialog = false">取消</el-button>
            </template>
        </el-dialog>

        <!-- 导入人群包（三步向导） -->
        <el-dialog v-model="impDialog" title="导入人群包" width="640px" align-center :close-on-click-modal="false" :close-on-press-escape="false" @close="impReset">
            <div class="imp-steps">
                <template v-for="(s, i) in IMP_STEPS" :key="i">
                    <div class="imp-step" :class="{ on: impStep === i + 1, done: impStep > i + 1 }">
                        <span class="dot-n">{{ impStep > i + 1 ? '✓' : (i + 1) }}</span>{{ s }}
                    </div>
                    <div v-if="i < IMP_STEPS.length - 1" class="imp-line"></div>
                </template>
            </div>

            <!-- 步骤 1：上传文件 -->
            <div v-if="impStep === 1">
                <el-upload class="imp-drop" drag action="#" :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls,.csv" :on-change="impPickFile">
                    <div class="imp-drop-t">点击上传名单文件，或拖拽到此处</div>
                    <div class="imp-drop-s">支持 .xlsx / .xls / .csv，单次最多 100,000 行<br>名单需包含「手机号」「好友关系ID」两列（每行至少填一列）</div>
                </el-upload>
                <div class="imp-tpl-row">
                    <span class="imp-link" @click="downloadImpTpl">下载导入模板</span>
                </div>
                <div v-if="impFileName" class="imp-file">
                    <div class="imp-file-badge">XLS</div>
                    <div style="flex:1">
                        <div class="imp-file-name">{{ impFileName }}</div>
                        <div class="imp-file-meta">已解析 {{ impRows.length }} 行 · 识别到 2 个可用列</div>
                    </div>
                    <span class="imp-link" @click="impResetFile">重新选择</span>
                </div>
            </div>

            <!-- 步骤 2：字段匹配 -->
            <div v-else-if="impStep === 2">
                <label class="imp-label">字段匹配</label>
                <div class="imp-map">
                    <div class="imp-map-row">
                        <div class="imp-col">手机号</div>
                        <span class="imp-arrow">→</span>
                        <div class="imp-sys">手机号（匹配已有客户）</div>
                    </div>
                    <div class="imp-map-row">
                        <div class="imp-col">好友关系ID</div>
                        <span class="imp-arrow">→</span>
                        <div class="imp-sys">好友关系ID（匹配已有客户）</div>
                    </div>
                </div>
                <p class="dl-note">每行按「好友关系ID 优先、手机号兜底」匹配已有客户；名单内重复记录自动去重，匹配不到客户的记录将被跳过。</p>
            </div>

            <!-- 步骤 3：校验并创建 -->
            <div v-else>
                <div class="imp-res">
                    <div class="imp-res-card"><div class="imp-res-num">{{ impRows.length }}</div><div class="imp-res-label">文件行数</div></div>
                    <div class="imp-res-card"><div class="imp-res-num" style="color:#10B981">{{ impValidCount }}</div><div class="imp-res-label">有效行数</div></div>
                    <div class="imp-res-card"><div class="imp-res-num" style="color:#D97706">{{ impInvalidCount }}</div><div class="imp-res-label">无效行数</div></div>
                </div>
                <p v-if="impInvalidCount" class="imp-warn">有 <b>{{ impInvalidCount }}</b> 条记录格式不正确（手机号需为 11 位数字，好友关系ID 需为正整数），已跳过，不影响其余记录。
                    <span class="imp-link" style="margin-left:8px" @click="exportImpInvalid">导出失败名单</span>
                </p>
                <div class="imp-frow">
                    <div>
                        <label class="imp-label">人群名称</label>
                        <el-input v-model="impName" placeholder="如：双11大促名单" />
                    </div>
                    <div>
                        <label class="imp-label">人群分类</label>
                        <el-input v-model="impCat" placeholder="如：营销转化" />
                    </div>
                </div>
                <p class="dl-note" style="margin-top:12px">创建后立即生成一份固定名单快照，后续不再自动更新。</p>
            </div>

            <template #footer>
                <el-button @click="impDialog = false">取消</el-button>
                <el-button v-if="impStep > 1" @click="impStep--">上一步</el-button>
                <el-button type="primary" :loading="impSaving" @click="impNext">{{ impStep >= 3 ? '创建人群' : '下一步' }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import * as XLSX from 'xlsx'
//导入分页组件（Element Plus 翻页组件封装）
import pagechange from '../components/pagechange.vue'
//导入人群列表/编辑/删除接口
import { newgetcirclelist, newupdatecircle, newdeletecircle, newrecalculatecircle, newaudienceexport, newekhexport, newimportcircle } from '@/assets/js/common.js'

//路由跳转
const router = useRouter()

/* ============== 工具 ============== */
function fmtInt(v) { return Math.round(v).toLocaleString('en-US'); }
function pad2(n) { return n < 10 ? '0' + n : '' + n; }

/* ============== 状态 ============== */
//状态映射（接口 status：0待计算 1计算中 2已完成 3计算失败）
var CAL_STATUS = { 0: ['badge-cal-pending', '待计算'], 1: ['badge-cal-run', '计算中'], 2: ['badge-cal-done', '已完成'], 3: ['badge-cal-failed', '计算失败'] };
var state = reactive({ q: '', page: 1, editing: null });
//顶部统计（summary：audience_total 人群总数 / member_cover_total 累计覆盖客户 / current_month_created_count 本月新增，接口返回前显示 —）
var summary = reactive({ audience_total: null, member_cover_total: null, current_month_created_count: null });
//列表加载中
const loading = ref(false)

//状态样式
function calStatusCls(status) { return (CAL_STATUS[status] || CAL_STATUS[2])[0]; }
function calStatusLabel(status) { return (CAL_STATUS[status] || CAL_STATUS[2])[1]; }

/* ============== 客户人群数据（由列表接口填充，无兜底数据） ============== */
var DATA = reactive([])
//总条数（服务端分页，由接口返回 total）
const mgmtTotalCount = ref(0)

/* ============== 人群列表接口（newgetcirclelist） ============== */
//拉取人群管理列表（无兜底数据）
const getList = () => {
    loading.value = true;
    newgetcirclelist({ page: state.page, page_size: 20, keyword: (state.q || '').trim() }).then((response) => {
        loading.value = false;
        if (response.data.msg.code == 0) {
            //顶部统计：人群总数 audience_total / 累计覆盖客户 member_cover_total（均在 summary 内）
            var sum = response.data.data && response.data.data.summary;
            if (sum) {
                if (sum.audience_total != null) summary.audience_total = sum.audience_total;
                if (sum.member_cover_total != null) summary.member_cover_total = sum.member_cover_total;
            }
            //本月新增 current_month_created_count（在 data 顶层，不在 summary 内）
            var monthNew = response.data.data && response.data.data.current_month_created_count;
            if (monthNew != null) summary.current_month_created_count = monthNew;
            //总条数 total（在 data 顶层）
            if (response.data.data && response.data.data.total != null) mgmtTotalCount.value = response.data.data.total;
            var list = (response.data.data && response.data.data.list) ? response.data.data.list : (Array.isArray(response.data.data) ? response.data.data : []);
            DATA.splice(0, DATA.length);
            list.forEach(function (i) {
                DATA.push({
                    id: i.id,
                    name: i.name || i.title || '',
                    cat: i.category || i.cat || '',
                    type: (i.is_import === '1' || i.is_import === 1 || i.is_import === true) ? 'import' : 'rule',
                    count: i.count || i.customer_count || 0,
                    member_count: i.member_count || 0,
                    owner: i.created_by_name || i.owner || i.create_by || i.creator || '',
                    created: i.created_at || i.created || i.create_time || '',
                    update: i.updated_at || i.update || '',
                    lastSync: i.last_calculated_at || i.last_sync_at || i.last_sync || '',
                    status: i.status != null ? i.status : 2
                });
            });
        }
    }).catch(() => {
        loading.value = false;
    })
}

/* ============== 客户人群：表格（Element Plus el-table） ============== */
//总条数（服务端分页，取接口返回的 total）
const mgmtTotal = computed(() => mgmtTotalCount.value);
//当前页数据（服务端分页，直接展示接口返回的 list）
const mgmtRows = computed(() => DATA);
//搜索输入（el-input 监听，实时搜索，入参 keyword；300ms 防抖）
var searchTimer = null;
const onSearchInput = () => {
    state.page = 1;
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { getList(); }, 300);
}
//分页切换（服务端分页，切换后重新请求）
const mgmtPageChange = (val) => { state.page = val; getList(); }
//同步全部
const onSyncAll = () => { runSync(DATA.map(function (d) { return d.name; })); }
//去智能圈选
const goSeg = () => { newCrowdDialog.value = false; router.push('/navkh/circlepeopleedit'); }
//行操作：重新计算（调用接口 /api/audience/recalculate，成功后刷新列表，不本地改状态）
const onRecalc = (row) => {
    if (row.id == null || row.id === '') { ElMessage.warning('该人群无 id，无法重新计算'); return; }
    newrecalculatecircle({ id: row.id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({ message: '重新计算成功', type: 'success' });
            getList();
        }
    }).catch(() => {
        ElMessage.error('重新计算失败，请稍后重试');
    });
}
//行操作：同步
const onSyncRow = (row) => { runSync(row.name); }
//行操作：查看人群（携带人群信息跳转详情页）
const onViewRow = (row) => {
    router.push({
        path: '/navkh/circlepeople',
        query: {
            id: row.id,
            name: row.name,
            cat: row.cat,
            count: row.member_count,
            owner: row.owner,
            update: row.update,
            last_calculated_at: row.lastSync,
            status: row.status
        }
    });
}
//行操作：编辑
const onEditRow = (row) => { openEdit(row); }
//行操作：删除
const onDelRow = (row) => { delName.value = row.name; delDialog.value = true; }
//行操作：导出人群成员（POST /api/audience/export，仅已完成状态可导出，成功后在导出记录中下载）
const onExportRow = (row) => {
    if (row.id == null || row.id === '') { ElMessage.warning('该人群无 id，无法导出'); return; }
    newaudienceexport({ id: row.id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({ message: '正在导出，请稍后在导出记录中下载', type: 'success' });
        }
    })
}

/* ============== 新建人群：选择创建方式 + 导入人群包（名单导入创建人群） ============== */
const newCrowdDialog = ref(false)
//导入向导步骤名
const IMP_STEPS = ['上传文件', '字段匹配', '校验并创建']
const impDialog = ref(false)
const impStep = ref(1)
const impFileName = ref('')
const impRows = ref([])
const impName = ref('')
const impCat = ref('')
const impSaving = ref(false)
//打开新建人群（选择创建方式）
const openNewCrowd = () => { newCrowdDialog.value = true; }
//打开导入人群包向导（重置状态）
const openImport = () => {
    newCrowdDialog.value = false;
    impReset();
    impDialog.value = true;
}
const impReset = () => {
    impStep.value = 1;
    impFileName.value = '';
    impRows.value = [];
    impName.value = '';
    impCat.value = '';
    impSaving.value = false;
}
//下载导入模板（第一列手机号、第二列好友关系ID，每行至少填一列）
const downloadImpTpl = () => {
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet([
        ['手机号', '好友关系ID'],
        ['13800138000', '123456'],
        ['13900139000', '']
    ]);
    XLSX.utils.book_append_sheet(wb, ws, '人群包名单');
    XLSX.writeFile(wb, '人群包导入模板.xlsx');
}
//选择文件后解析（.xlsx / .xls / .csv 均由 SheetJS 解析；第一列手机号、第二列好友关系ID）
const impPickFile = (uploadFile) => {
    var raw = uploadFile.raw;
    if (!raw) return;
    var reader = new FileReader();
    reader.onload = (e) => {
        try {
            var wb = XLSX.read(e.target.result, { type: 'array' });
            var sheet = wb.Sheets[wb.SheetNames[0]];
            var rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
            //首行含表头关键字则跳过
            if (rows.length && impIsHeader(rows[0])) rows.shift();
            impRows.value = rows.map(function (r) { return Array.isArray(r) ? r : [r]; });
            impFileName.value = raw.name || '名单文件';
        } catch (err) {
            ElMessage.error('文件解析失败，请使用模板格式的 .xlsx / .xls / .csv 文件');
        }
    };
    reader.readAsArrayBuffer(raw);
}
//表头识别（模板列名及常见别名）
const impIsHeader = (r) => {
    var a = String(r[0] == null ? '' : r[0]).trim();
    var b = String(r[1] == null ? '' : r[1]).trim();
    return /手机|电话|号码|phone|好友|关系|^id$/i.test(a) || /手机|电话|号码|phone|好友|关系|^id$/i.test(b);
}
//重新选择文件
const impResetFile = () => { impFileName.value = ''; impRows.value = []; }
//名单行校验与归一（第一列手机号、第二列好友关系ID；空行跳过，格式错误计入无效并记录失败原因）
function normalizeImpRows() {
    var valid = [], invalid = [];
    impRows.value.forEach(function (r) {
        var phone = String(r[0] == null ? '' : r[0]).trim();
        var rel = String(r[1] == null ? '' : r[1]).trim();
        if (!phone && !rel) return;                       //空行直接跳过
        var phoneOk = phone === '' || /^1\d{10}$/.test(phone);
        var relOk = rel === '' || /^\d+$/.test(rel);
        if (!phoneOk || !relOk) {
            var reasons = [];
            if (!phoneOk) reasons.push('手机号需为 11 位数字');
            if (!relOk) reasons.push('好友关系ID需为正整数');
            invalid.push({ phone: phone, rel: rel, reason: reasons.join('；') });
            return;
        }
        var item = { phone: phone };                      //好友关系ID留空时不传，后端以手机号兜底
        if (rel !== '') item.relation_id = parseInt(rel, 10);
        valid.push(item);
    });
    return { valid: valid, invalid: invalid };
}
const impValidCount = computed(() => normalizeImpRows().valid.length);
const impInvalidCount = computed(() => normalizeImpRows().invalid.length);
//导出失败名单：保留原表两列（手机号 / 好友关系ID），末尾追加「失败原因」列
const exportImpInvalid = () => {
    var invalid = normalizeImpRows().invalid;
    if (!invalid.length) { ElMessage.warning('没有可导出的失败记录'); return; }
    var aoa = [['手机号', '好友关系ID', '失败原因']];
    invalid.forEach(function (it) {
        aoa.push([it.phone, it.rel, it.reason]);
    });
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(aoa);
    XLSX.utils.book_append_sheet(wb, ws, '失败名单');
    XLSX.writeFile(wb, '导入失败名单.xlsx');
}
//向导下一步 / 最后一步创建人群
const impNext = () => {
    if (impStep.value === 1) {
        if (!impFileName.value) { ElMessage.warning('请先上传名单文件'); return; }
        impStep.value = 2;
    } else if (impStep.value === 2) {
        impStep.value = 3;
    } else {
        onImportCreate();
    }
}
//创建导入人群（POST /api/audience/import）
const onImportCreate = () => {
    var nm = (impName.value || '').trim(), ct = (impCat.value || '').trim();
    if (!nm || !ct) { ElMessage.error('人群名称和人群分类不能为空'); return; }
    var stat = normalizeImpRows();
    if (!stat.valid.length) { ElMessage.warning('没有可导入的有效名单行'); return; }
    impSaving.value = true;
    newimportcircle({ name: nm, category: ct, values: stat.valid }).then((response) => {
        impSaving.value = false;
        if (response.data.msg.code == 0) {
            ElMessage({ message: '导入成功，正在计算人群', type: 'success' });
            impDialog.value = false;
            impReset();
            getList();
        } else {
            ElMessage.error(response.data.msg.info || '导入失败，请稍后重试');
        }
    }).catch(() => {
        impSaving.value = false;
        ElMessage.error('导入失败，请稍后重试');
    });
}

/* ============== 导出记录（人群成员导出 type=2） ============== */
const exportListDialog = ref(false)
const exportListRows = ref([])
//打开导出记录（POST /api/export/list，type=2 人群成员导出）
const openExportList = () => {
    exportListDialog.value = true;
    exportListRows.value = [];
    newekhexport({ type: 2, page: 1, page_size: 200000 }).then((response) => {
        if (response.data.msg.code == 0) {
            var d = response.data.data;
            exportListRows.value = (d && d.data) ? d.data : [];
        }
    })
}
//导出记录-下载
const handleExportDown = (url) => {
    if (!url) { ElMessage.warning('下载地址为空'); return; }
    const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', url);
    a.click();
}

/* ============== 编辑人群 ============== */
const editDialog = ref(false)
const editName = ref('')
const editCat = ref('')
function openEdit(row) {
    state.editing = row;
    editName.value = row.name;
    editCat.value = row.cat;
    editDialog.value = true;
}
const onEditConfirm = () => {
    var nm = (editName.value || '').trim(), ct = (editCat.value || '').trim();
    if (!nm || !ct) { ElMessage.error('人群名称和人群分类不能为空'); return; }
    if (!state.editing) return;
    var row = state.editing;
    //有 id 走编辑接口；演示数据（无 id）仅本地修改
    if (row.id != null && row.id !== '') {
        newupdatecircle({ id: row.id, name: nm, category: ct }).then((response) => {
            if (response.data.msg.code == 0) {
                row.name = nm;
                row.cat = ct;
                editDialog.value = false;
                ElMessage({ message: '编辑成功', type: 'success' });
            }
        })
    } else {
        row.name = nm;
        row.cat = ct;
        editDialog.value = false;
    }
}

/* ============== 删除人群 ============== */
const delDialog = ref(false)
const delName = ref('')
const onDelConfirm = () => {
    var row = DATA.find(function (d) { return d.name === delName.value; });
    if (!row) { delDialog.value = false; return; }
    var removeLocal = function () {
        var i = DATA.indexOf(row);
        if (i >= 0) DATA.splice(i, 1);
        delDialog.value = false;
    };
    //有 id 走删除接口；演示数据（无 id）仅本地删除
    if (row.id != null && row.id !== '') {
        newdeletecircle({ id: row.id }).then((response) => {
            if (response.data.msg.code == 0) {
                removeLocal();
                ElMessage({ message: '删除成功', type: 'success' });
            }
        })
    } else {
        removeLocal();
    }
}

/* ============== 人群同步 · 失效剔除（规则人群，手动触发） ============== */
var SYNC_LOGS = [];
const syncDialog = ref(false)
const syncRows = ref([])
const syncSummaryHtml = ref('')
function runSync(names) {
    if (typeof names === 'string') names = [names];
    var d0 = new Date();
    var ts = d0.getFullYear() + '-' + pad2(d0.getMonth() + 1) + '-' + pad2(d0.getDate()) + ' ' + pad2(d0.getHours()) + ':' + pad2(d0.getMinutes());
    var totalRemoved = 0;
    names.forEach(function (nm) {
        var d = DATA.find(function (x) { return x.name === nm; });
        if (!d) return;
        //第一期仅按「年龄 / 黑名单」两项重判：圈选时满足、后续不满足的静默移出
        var byAge = Math.round(d.count * (0.01 + Math.random() * 0.025));      //年龄跨区间失效 ~1%~3.5%
        var byBlack = Math.round(d.count * (0.003 + Math.random() * 0.006));   //被加入黑名单 ~0.3%~0.9%
        var removed = byAge + byBlack;
        d.count = Math.max(0, d.count - removed);
        d.update = ts;
        d.lastSync = ts;
        totalRemoved += removed;
        SYNC_LOGS.unshift({ time: ts, name: nm, removed: removed, byAge: byAge, byBlack: byBlack, keep: d.count });
    });
    showSyncModal(names, totalRemoved);
}
function showSyncModal(names, totalRemoved) {
    if (typeof names === 'string') names = [names];
    syncRows.value = SYNC_LOGS.filter(function (l) { return names.indexOf(l.name) >= 0; });
    syncSummaryHtml.value = '本次同步 <b>' + names.length + '</b> 个人群，检测维度：<b>年龄 / 黑名单</b>。'
        + '共剔除 <b style="color:var(--red)">' + totalRemoved + '</b> 人（不再满足条件的成员已<b>静默移出</b>，并写入操作日志）；其余成员保留。';
    syncDialog.value = true;
}

/* ============== 初始化 ============== */
onMounted(() => {
    getList();
});
</script>

<style scoped>
.circle-page {
    --bg: #F7F8FC;
    --card: #ffffff;
    --primary: #4F46E5;
    --primary2: #7C3AED;
    --primarySoft: #A5B4FC;
    --red: #EF4444;
    --green: #10B981;
    --amber: #F59E0B;
    --text: #1E293B;
    --muted: #64748B;
    --grid: #EEF1F6;
    --border: #E8ECF3;
    --shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    --radius: 14px;
}

.container { max-width: none; margin: 0; padding: 0 0 20px; }
.grow { flex: 1; }
.page-title { font-size: 21px; font-weight: 800; margin: 4px 0 18px; }
.page-title small { font-weight: 500; color: var(--muted); font-size: 14px; margin-left: 10px; }

/* 按钮 */
.btn-primary { background: linear-gradient(90deg, var(--primary), var(--primary2)); color: #fff; border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 700; cursor: pointer; font-size: 14px; }
.btn-primary:hover { opacity: .92; }
.btn-ghost { background: #F1F3F9; color: var(--text); border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 600; cursor: pointer; font-size: 14px; }
.btn-ghost:hover { background: #E7EAF2; }
.btn-sm { padding: 6px 12px; font-size: 13.5px; border-radius: 8px; }
.btn-primary:focus-visible, .btn-ghost:focus-visible { outline: none; }

/* 统计卡片 */
.stat-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 18px; }
.stat-card { background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); padding: 16px 18px; }
.stat-label { font-size: 13.5px; color: var(--muted); font-weight: 600; }
.stat-value { font-size: 29px; font-weight: 800; color: var(--text); margin-top: 4px; }
.stat-value .unit { font-size: 15px; font-weight: 600; color: var(--muted); margin-left: 4px; }
.stat-sub { font-size: 13px; color: var(--muted); margin-top: 4px; }
.stat-card .dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 6px; vertical-align: middle; }

/* 工具栏 */
.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; flex-wrap: wrap; }
.toolbar .spacer { flex: 1; }
.search-input { width: 240px; }
.search-input :deep(.el-input__wrapper) {
    border-radius: 10px;
    box-shadow: 0 0 0 1px var(--border) inset;
    background: #fff;
    padding: 1px 12px;
    font-size: 14px;
}
.search-input :deep(.el-input__wrapper.is-focus) { box-shadow: 0 0 0 1px var(--primary) inset; }
.search-input :deep(.el-input__inner) { height: 36px; color: var(--text); font-size: 14px; }

/* 表格 */
.table-wrap { background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); padding: 6px 4px; overflow: hidden; }
.name-cell { font-weight: 700; color: var(--text); }
.count-cell { font-weight: 800; color: var(--primary); }
.muted-cell { color: var(--muted); }
.badge { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 700; line-height: 1.3; padding: 4px 11px; border-radius: 999px; }
.badge::before { content: ""; width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.badge-cal-run { color: var(--primary); background: rgba(79, 70, 229, .12); }
.badge-cal-done { color: var(--green); background: rgba(16, 185, 129, .12); }
.badge-cal-failed { color: #EF4444; background: rgba(239, 68, 68, .12); }
.badge-cal-pending { color: var(--amber); background: rgba(245, 158, 11, .12); }
.type-tag { display: inline-block; font-size: 12px; font-weight: 600; padding: 2px 9px; border-radius: 999px; }
.type-tag.imp { color: var(--primary); background: rgba(79, 70, 229, .12); }
.type-tag.rule { color: var(--muted); background: #F1F3F9; }
.op { color: var(--primary); font-weight: 600; cursor: pointer; margin-right: 12px; font-size: 14px; }
.op:hover { text-decoration: underline; }
.op-del { color: var(--red); }
.op-del:hover { text-decoration: underline; }

/* Element Plus 组件：参考页面样式适配 */
.ref-table {
    --el-table-border-color: #EEF1F6;
    --el-table-header-bg-color: #FBFCFE;
    --el-table-header-text-color: #64748B;
    --el-table-row-hover-bg-color: #F8FAFF;
    font-size: 14.5px;
}
.ref-table :deep(.el-table__cell) { padding: 13px 0; }
.ref-table :deep(.el-table .cell) { padding: 0 16px; }
.ref-table :deep(.el-table__header th) { font-weight: 700; font-size: 14px; }
.ref-table :deep(.el-table__empty-text) { color: var(--muted); font-size: 14px; padding: 34px 0; }

@media (max-width: 1180px) {
    .stat-row { grid-template-columns: repeat(2, 1fr); }
}
</style>

<style>
/* ============== 新建人群选择 / 导入人群包弹窗（el-dialog 挂载到 body，需全局样式，颜色用固定值） ============== */
.choose-hint { margin: 0 0 14px; font-size: 13.5px; color: #64748B; line-height: 1.7; }
.choose-list { display: flex; flex-direction: column; gap: 10px; }
.choose-card { display: flex; align-items: flex-start; gap: 12px; border: 1px solid #E8ECF3; border-radius: 12px; padding: 14px 16px; cursor: pointer; transition: border-color .15s, background .15s; }
.choose-card:hover { border-color: #4F46E5; background: #F8FAFF; }
.choose-ico { width: 34px; height: 34px; border-radius: 9px; display: grid; place-items: center; font-size: 14px; font-weight: 800; flex-shrink: 0; }
.src-rule { color: #4F46E5; background: rgba(79, 70, 229, .10); }
.src-import { color: #0284C7; background: rgba(14, 165, 233, .13); }
.choose-t { font-size: 15px; font-weight: 700; color: #1E293B; }
.choose-s { font-size: 13px; color: #64748B; line-height: 1.7; margin-top: 3px; }
.modal-actions { display: flex; gap: 10px; margin-top: 18px; }
.modal-actions .btn-ghost { flex: 1; }
.btn-ghost { background: #F1F3F9; color: #1E293B; border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 600; cursor: pointer; font-size: 13px; }
.btn-ghost:hover { background: #E7EAF2; }

.imp-steps { display: flex; align-items: center; gap: 10px; margin: 2px 0 20px; }
.imp-step { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #64748B; font-weight: 600; white-space: nowrap; }
.imp-step .dot-n { width: 22px; height: 22px; border-radius: 50%; display: grid; place-items: center; font-size: 12px; background: #F1F3F9; color: #64748B; }
.imp-step.on { color: #4F46E5; }
.imp-step.on .dot-n { background: #4F46E5; color: #fff; }
.imp-step.done { color: #10B981; }
.imp-step.done .dot-n { background: rgba(16, 185, 129, .15); color: #10B981; }
.imp-line { flex: 1; height: 1px; background: #EEF1F6; min-width: 24px; }

.imp-drop { width: 100%; }
.imp-drop .el-upload { width: 100%; }
.imp-drop .el-upload-dragger { width: 100%; border: 1px dashed #E8ECF3; border-radius: 12px; padding: 34px 16px; background: #FAFBFE; }
.imp-drop .el-upload-dragger:hover { border-color: #4F46E5; background: #F8FAFF; }
.imp-drop-t { font-size: 14.5px; font-weight: 600; color: #1E293B; }
.imp-drop-s { font-size: 13px; color: #64748B; line-height: 1.8; margin-top: 6px; }
.imp-tpl-row { display: flex; justify-content: flex-end; margin-top: 10px; }
.imp-link { color: #4F46E5; font-weight: 600; cursor: pointer; font-size: 14px; }
.imp-link:hover { text-decoration: underline; }

.imp-file { display: flex; align-items: center; gap: 12px; margin-top: 12px; padding: 12px 14px; border: 1px solid #E8ECF3; border-radius: 12px; background: #FAFBFE; }
.imp-file-badge { width: 34px; height: 34px; border-radius: 8px; background: linear-gradient(135deg, #4F46E5, #7C3AED); color: #fff; display: grid; place-items: center; font-size: 11px; font-weight: 800; flex-shrink: 0; }
.imp-file-name { font-weight: 700; font-size: 14px; color: #1E293B; }
.imp-file-meta { font-size: 12.5px; color: #64748B; margin-top: 2px; }

.imp-label { display: block; font-size: 13.5px; color: #64748B; font-weight: 600; margin: 14px 0 6px; }
.imp-map { border: 1px solid #E8ECF3; border-radius: 12px; padding: 4px 14px; }
.imp-map-row { display: flex; align-items: center; gap: 10px; padding: 9px 0; border-bottom: 1px dashed #EEF1F6; }
.imp-map-row:last-child { border-bottom: 0; }
.imp-col { min-width: 110px; font-weight: 600; color: #1E293B; }
.imp-arrow { color: #94A3B8; }
.imp-sys { color: #4F46E5; font-weight: 600; font-size: 13px; background: rgba(79, 70, 229, .08); padding: 3px 10px; border-radius: 999px; }

.dl-note { font-size: 13px; color: #64748B; line-height: 1.7; margin: 10px 0 0; }
.imp-res { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-top: 4px; }
.imp-res-card { background: #FAFBFE; border: 1px solid #E8ECF3; border-radius: 12px; padding: 14px 8px; text-align: center; }
.imp-res-num { font-size: 24px; font-weight: 800; color: #1E293B; }
.imp-res-label { font-size: 12.5px; color: #64748B; margin-top: 3px; }
.imp-warn { margin-top: 12px; font-size: 13px; color: #B45309; background: rgba(217, 119, 6, .08); border: 1px solid rgba(217, 119, 6, .22); border-radius: 10px; padding: 8px 12px; line-height: 1.7; }
.imp-frow { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 14px; }
.imp-frow .el-input__wrapper { border-radius: 10px; box-shadow: 0 0 0 1px #E8ECF3 inset; background: #fff; padding: 1px 12px; }
.imp-frow .el-input__wrapper.is-focus { box-shadow: 0 0 0 1px #4F46E5 inset; }
.imp-frow .el-input__inner { font-size: 14px; color: #1E293B; }
</style>
